module.exports = __webpack_public_path__ + "img/12_83.725adeb4.png";